import { Button, Card, Col, Input, Row, Select, Typography } from "antd"
import AuthCMS from "../../Layouts/AuthCMS"
import List from "../../Commons/BasicModule/List"
import { useState } from "react"
import { checkProxyFetch } from "./API"

const modelField = ['no', 'proxy', 'ipaddress', 'status', 'type']

const columnTable = modelField.map((field) => ({
    title: field.toUpperCase(),
    dataIndex: field,
    key: field,
}))

const CheckProxy = () => {
    const [proxyFormat, setProxyFormat] = useState("host:port:username:password")
    const [proxyType, setProxyType] = useState("http")
    const [proxyListText, setProxyListText] = useState("")

    const [activeProxies, setActiveProxies] = useState("")
    const [inactiveProxies, setInactiveProxies] = useState("")
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    
    // Add counting states
    const [totalCount, setTotalCount] = useState(0)
    const [activeCount, setActiveCount] = useState(0)
    const [inactiveCount, setInactiveCount] = useState(0)

    const onCheckProxy = () => {
        // Count total proxies before checking
        const inputProxies = proxyListText
            .split("\n")
            .map(line => line.trim())
            .filter(line => line);
        
        setTotalCount(inputProxies.length)
        setLoading(true)
        
        checkProxyFetch({ proxy_list: proxyListText, proxy_type: proxyType }).then((res) => {
            const data = res.data || []
    
            let no = 1
            const formattedData = data.map((item) => {
                return {
                    no: no++,
                    proxy: item.proxy,
                    ipaddress: item.ip || "",
                    status: item.status === "Live" ? "✔︎" : "✘",
                    type: item.type.toUpperCase()
                }
            })
    
            const actives = data.filter(item => item.status === "Live").map(p => p.proxy).join("\n")
            const inactives = data.filter(item => item.status !== "Live").map(p => p.proxy).join("\n")
            
            // Update counts
            const activeProxyCount = data.filter(item => item.status === "Live").length
            const inactiveProxyCount = data.filter(item => item.status !== "Live").length
            
            setActiveCount(activeProxyCount)
            setInactiveCount(inactiveProxyCount)
            setActiveProxies(actives)
            setInactiveProxies(inactives)
            setTableData(formattedData)
        }).finally(() => setLoading(false))
    }
    
    const onCopy = (text) => {
        navigator.clipboard.writeText(text)
    }

    return <AuthCMS tabActive={"/checkproxy"}>
        <Row gutter={[8, 8]} style={{ margin: 8 }}>
            <Col xs={24} md={10}>
                <Card>
                    <div>
                        <Typography.Title level={5}>Proxy Format</Typography.Title>
                        <Select style={{ width: "100%" }} value={proxyFormat} onChange={(v) => setProxyFormat(v)}>
                            <Select.Option value="host:port:username:password">host:port:username:password</Select.Option>
                            <Select.Option value="username:password@host:port">username:password@host:port</Select.Option>
                            <Select.Option value="username:password:host:port">username:password:host:port</Select.Option>
                            <Select.Option value="host:port@username:password">host:port@username:password</Select.Option>
                            <Select.Option value="host:port">host:port</Select.Option>
                        </Select>
                    </div>
                    <div>
                        <Typography.Title level={5}>Proxy Type</Typography.Title>
                        <Select style={{ width: "100%" }} value={proxyType} onChange={(v) => setProxyType(v)}>
                            <Select.Option value="http">http</Select.Option>
                            <Select.Option value="socks5">socks5</Select.Option>
                        </Select>
                    </div>
                    <div>
                        <Typography.Title level={5}>Proxy List</Typography.Title>
                        <Input.TextArea
                            rows={4}
                            onChange={(e) => setProxyListText(e.target.value)}
                            value={proxyListText}
                            placeholder="..."
                        ></Input.TextArea>
                    </div>
                    <div>
                        <Button type="primary" style={{ width: "100%", margin: "8px 0" }} onClick={onCheckProxy} loading={loading}>✔︎ Check</Button>
                    </div>
                    
                    {/* Proxy Statistics */}
                    {totalCount > 0 && (
                        <div style={{ 
                            background: '#f5f5f5', 
                            padding: '12px', 
                            borderRadius: '6px', 
                            marginBottom: '16px',
                            border: '1px solid #d9d9d9'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span><strong>Total:</strong> {totalCount}</span>
                                <span style={{ color: '#52c41a' }}><strong>Active:</strong> {activeCount}</span>
                                <span style={{ color: '#ff4d4f' }}><strong>Inactive:</strong> {inactiveCount}</span>
                            </div>
                            <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
                                Success Rate: {totalCount > 0 ? ((activeCount / totalCount) * 100).toFixed(1) : 0}%
                            </div>
                        </div>
                    )}
                    
                    <div className="border-dashed w-full border-2 mt-2 mb-2"></div>
                    <div>
                        <Typography.Title level={5}>Active Proxies ({activeCount})</Typography.Title>
                        <Input.TextArea
                            rows={4}
                            value={activeProxies}
                            readOnly
                        ></Input.TextArea>
                        <Button type="primary" style={{ width: "100%", margin: "8px 0" }} onClick={() => onCopy(activeProxies)}>Copy</Button>
                    </div>
                    <div>
                        <Typography.Title level={5}>Inactive Proxies ({inactiveCount})</Typography.Title>
                        <Input.TextArea
                            rows={4}
                            value={inactiveProxies}
                            readOnly
                        ></Input.TextArea>
                        <Button type="primary" style={{ width: "100%", margin: "8px 0" }} onClick={() => onCopy(inactiveProxies)}>Copy</Button>
                    </div>
                </Card>
            </Col>
            <Col xs={24} md={14}>
                <Card>
                    <div>
                        <Typography.Title level={5}> 🌎 Proxy Check Results ({tableData.length} proxies)</Typography.Title>
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: '16px' }}>Checking proxies...</div>
                        ) : (
                            <List
                                columnTable={columnTable}
                                dataList={tableData}
                                isHideAction={true}
                                rowKey={'no'}
                                pagination={false}
                            />
                        )}
                    </div>
                </Card>
            </Col>
        </Row>
    </AuthCMS>
}

export default CheckProxy